import React from 'react';
import { usePropChange } from '../../hooks';
export function useFiltersBarState(initialFilterData, onFilter, onFilterDebounceDelay) {
    const [appliedFilterData, setAppliedFilterData] = React.useState(initialFilterData);
    const onFilterTimeoutRef = React.useRef(undefined);
    const onFilterDebounce = React.useCallback((newFilterData) => {
        if (onFilterTimeoutRef.current != null) {
            window.clearTimeout(onFilterTimeoutRef.current);
        }
        onFilterTimeoutRef.current = window.setTimeout(() => {
            if (JSON.stringify(appliedFilterData) !== JSON.stringify(newFilterData)) {
                onFilter(newFilterData);
            }
        }, onFilterDebounceDelay);
    }, [onFilter, onFilterDebounceDelay, appliedFilterData]);
    const onChangeFilterData = React.useCallback((action) => {
        setAppliedFilterData((prevAppliedFilterData) => {
            const newFilterData = action(prevAppliedFilterData);
            if (JSON.stringify(prevAppliedFilterData) !== JSON.stringify(newFilterData)) {
                onFilterDebounce(newFilterData);
            }
            return newFilterData;
        });
    }, [onFilterDebounce]);
    const onClearFilters = React.useCallback(() => {
        setAppliedFilterData((prevAppliedFilterData) => {
            const newFilterData = {};
            if (JSON.stringify(prevAppliedFilterData) !== JSON.stringify(newFilterData)) {
                onFilterDebounce({});
            }
            return newFilterData;
        });
    }, [onFilterDebounce]);
    usePropChange(initialFilterData, React.useCallback((newFilterData) => {
        onFilter(newFilterData);
        setAppliedFilterData(newFilterData);
    }, [onFilter]));
    return {
        appliedFilterData,
        onChangeFilterData,
        onClearFilters,
    };
}
